import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { MatSnackBar } from '@angular/material';


// ************************************************ FOOTER COMPONENT CLASS ********************************************
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public lat: number = 40.678178;
  public lng: number = -73.944158;
  public zoom: number = 12;
  private isCurrentlySubscribing = false;


  // -- FUNC Constructor
  constructor(public appService: AppService, public snackBar: MatSnackBar) { }


  // -- FUN Ng On Init
  ngOnInit() { }


  // -- FUNC Subdcribe To News
  subscribeToNews() {

    var emailToSubscribe = (<HTMLInputElement>document.getElementById("subscribeEmailText")).value;

    // check if search reqeust isnt empty and if isnt then perfrom get searched products request
    if (emailToSubscribe != '' && this.checkIfEmailIsValid(emailToSubscribe)) {

      if (!this.isCurrentlySubscribing) {
        this.isCurrentlySubscribing = true;
        this.appService.subscribeToNews(emailToSubscribe).subscribe(data => {
          // check status and if it is ok then unpack received searched products list
          if (data['status'] == 1) {
            //console.log("TRUE ON SUBSCRIBE TO NEWS" + JSON.stringify(data));
            // tell user that the email has been added and clear email field
            this.snackBar.open('Спасибо! Email был успешно добавлен.', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
            (<HTMLInputElement>document.getElementById("subscribeEmailText")).value = '';
            this.isCurrentlySubscribing = false;
          }
          else {
            //console.log("FALSE ON SUBSCRIBE TO NEWS" + JSON.stringify(data));
            // -- check if false is cause email already exist and if yes then tell user about it
            if (data['exist'] == 'Yes') {
              this.snackBar.open('Введенные вами email уже был добавлен в список рассылки', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
              this.isCurrentlySubscribing = false;
            }
          }
        });
      }
    }

  }


  //-- Check If Email Is Valid
  private checkIfEmailIsValid(email: string) {

    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if (email != "" && (email.length <= 5 || !EMAIL_REGEXP.test(email))) {
      this.snackBar.open('Пожалуйста введите email', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
      return false;
    }

    return true;
  }


}
